let invocationId = 0;

export default class Supervisor {
    constructor(worker, opts) {
        this.worker = worker;
        this.callbacks = {};
        this.errorLogger = opts && opts.errorLogger;

        this.attachToWorker();

        const methods = opts && opts.methods;
        if (methods && Array.isArray(methods)) {
            methods.forEach(methodName => {
                Object.defineProperty(this, methodName, {
                    value(...args) {
                        return this.invoke(methodName, args);
                    }
                });
            });
        }
    }

    static getInvocationId() {
        return ++invocationId;
    }

    attachToWorker() {
        this.worker.addEventListener("message", message => {
            if (message.data.type !== "invokeResult") {
                return;
            }

            const data = message.data.data;
            const callbacks = this.callbacks[data.id];

            if (!callbacks) {
                return;
            }

            delete this.callbacks[data.id];

            if ("result" in data) {
                callbacks.resolve(data.result);
            } else if ("error" in data) {
                const error = new Error();

                Object.assign(error, data.error);

                callbacks.reject(error);
            }
        });
    }

    invoke(name, args) {
        return new Promise((resolve, reject) => {
            const id = this.constructor.getInvocationId();

            this.callbacks[id] = {
                resolve,
                reject
            };

            this.worker.postMessage({
                type: "invoke",
                data: {
                    id,
                    name,
                    args
                }
            });
        }).catch(error => {
            if (this.errorLogger) {
                this.errorLogger(error, {
                    fnName: name,
                    args
                });
            }

            throw error;
        });
    }

    terminate() {
        this.worker.terminate();
    }
}
